import {REFCODES} from '../constants/refCodes';

const getRefEmbedded = (url: string, feature: string, type: string) => {
  const TYPE_BASED: {[key: string]: string} = {
    normal: `${url}${url?.includes('?ref') ? '&' : '?'}ref=${
      REFCODES[feature]
    }`,
    org: `${url}${url?.includes('?ref') ? '&' : '?'}reforg=${
      REFCODES[feature]
    }&refinv=${REFCODES[feature]}`,
  };

  return TYPE_BASED[type];
};

export {getRefEmbedded};
